import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { ThemeOptions } from '../../../../../theme-options';
import { AuthenticateService } from '../../../../../shared/services/authenticate.service'
import { Router, ActivatedRoute } from '@angular/router';
import { ngxLoadingAnimationTypes, NgxLoadingComponent } from 'ngx-loading';
import { CognitoService } from 'src/app/shared/services/cognito.service';
@Component({
  selector: 'app-user-box',
  templateUrl: './user-box.component.html',
})
export class UserBoxComponent implements OnInit {

  @ViewChild('ngxLoading') ngxLoadingComponent: NgxLoadingComponent;
  @ViewChild('customLoadingTemplate') customLoadingTemplate: TemplateRef<any>;
  public ngxLoadingAnimationTypes = ngxLoadingAnimationTypes;
  name: string;
  email: string;
  globalImgUrl: string;
  public loading: boolean;
  toggleDrawer() {
    this.globals.toggleDrawer = !this.globals.toggleDrawer;
  }

  constructor(public globals: ThemeOptions, private authService: AuthenticateService, private cogService:CognitoService,private route: ActivatedRoute, private router: Router) {
  }
  ngDoCheck() {

    if (!this.globalImgUrl) {
      this.globalImgUrl = this.authService.s3url();
    }

    if (!this.name) {
      // console.log("this.authService.getUserDetails('group') ", this.authService.getUserDetails('family_name'))
      this.name = this.authService.getUserDetails('name');
      this.email = this.authService.getUserDetails('family_name');
    }

  }
  ngOnInit() {
    this.loading = false;
  }
  onImgError(event) {
    event.target.src = this.globalImgUrl + 'agri_logo.png';
  }
  logOutUser() {
    this.loading = true;
    console.log("logout funtion");
    // this.authService.logOut().then((res: any) => {
    //   console.log("user box logout result ", res);
    //   this.router.navigate(['/login']);
    //   this.loading = false;
    // });
    this.cogService.signOut().then((res:any) => {
      console.log("user box logout result ", res);
      this.router.navigate(['/login']);
      this.loading = false;
    })
  }
}